import React, { useEffect, useState } from 'react'
import { CaretUpFilled, CaretDownFilled } from '@ant-design/icons'
import styles from './index.module.less'
import classNames from 'classnames'

interface PriceProps {
  value?: number
  onChange?: Function
}
export default function Price({ value, onChange }: PriceProps) {
  const [activate, setActivate] = useState(0)

  useEffect(() => {
    setActivate(value || 0)
  }, [value])

  return (
    <div className={styles.sort}>
      <span
        className={classNames(styles.multiple, !activate && styles.sortOn)}
        onClick={() => {
          setActivate(0)
          onChange?.(0)
        }}
      >
        综合排序
      </span>
      <span className={styles.line}></span>
      <div className={styles.price}>
        <div
          className={styles.label}
          onClick={() => {
            let val = activate === 2 ? 1 : 2
            setActivate(val)
            onChange?.(val)
          }}
        >
          <span
            className={classNames(styles.labelText, activate && styles.sortOn)}
          >
            价格
          </span>
          <div className={styles.labelIcon}>
            <CaretUpFilled
              className={classNames(activate === 1 && styles.activate)}
              style={{ marginBottom: '-2px' }}
            />
            <CaretDownFilled
              className={classNames(activate === 2 && styles.activate)}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
